import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DictionaryRequestStatus } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'insurance-card-view',
  standalone: false,
  templateUrl: './insurance-card-view.component.html',
  styleUrl: './insurance-card-view.component.scss',
})
export class InsuranceCardViewComponent {
  @Input() insurances: app.models.InsuranceModel[];
  @Input() props: app.models.DynamicPropsDictionary;

  public dictionaryRequestStatus = DictionaryRequestStatus;

  constructor(private _router: Router) {}
  navigateToDetailHandler(id: string) {
    this._router.navigate(['insurances', id]);
  }
}
